<div class="crop-item-variety-name">
  {{ varietyName }}
  @if (varietalType) {
    <span
      class="ml-1"
      data-testid="crop-item-varietal-type"
      >({{ varietalType | translateConstant: varietalTypes }})</span
    >
  }
</div>
